import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { style } from 'typestyle';

import { getHeightForRows, SortableDataGrid } from '~src/common/react/components/dataGrid/SortableDataGrid3';
import { SliceableHelper } from '~src/ts/helpers/SliceableHelper';
import { ISliceable } from '~src/ts/models/ISliceable';
import { IOrderClause } from '~src/ts/ServerApi/types/IOrderClause';

import { flowParametersColumns, FlowParametersGridRow } from '../FlowParametersColumns';
import { FlowParameter, FlowParameterParams } from '../types/FlowParameters';


const parametersDatagridStyle = style({
  border: `1px solid ${TabStyles.Colors.L6}`,
});

function getRowData(parameters: FlowParameter[], parameterParams: FlowParameterParams[]): (orderClause: IOrderClause[]) => ISliceable<FlowParametersGridRow> {
  const parameterRows = parameters.map(parameter => {
    let parameterValue = parameter.value;
    if (parameterParams !== undefined) {
      const matchingOverride = parameterParams.find(parameterParam => parameterParam.id === parameter.id);
      if (matchingOverride !== undefined) {
        parameterValue = matchingOverride.overrideValue;
      }
    }
    return {
      parameterName: parameter.name,
      parameterValue: parameterValue,
      parameterDescription: parameter.description,
    };
  });
  return (_orderClause: IOrderClause[]) => SliceableHelper.fromArray(parameterRows);
}

export interface FlowParametersGridProps {
  parameters: FlowParameter[];
  parameterParams?: FlowParameterParams[]; // Override Values for Parameters
}

export function FlowParametersGrid(props: FlowParametersGridProps): JSX.Element {
  const sliceable = React.useMemo(
    () => getRowData(props.parameters, props.parameterParams),
    [props.parameters, props.parameterParams]
  );

  const parameterCount = Object.keys(props.parameters).length;

  const columns = flowParametersColumns();
  return (
    <div className={parametersDatagridStyle} style={{ height: getHeightForRows(parameterCount + 1) - 3 }}>
      <SortableDataGrid
        columns={columns}
        getSliceable={sliceable}
      />
    </div>
  );
}